import { useTheme } from "@/components/theme-provider"
import { Toaster as Sonner, type ToasterProps } from "sonner"
import {
  IconAlertWarningFill18,
  IconCircleCheckFill18,
  IconCircleInfoFill18,
  IconCircleXmarkFill18,
  IconLoader2Fill18,
} from "nucleo-ui-fill-18"

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      icons={{
        success: <IconCircleCheckFill18 className="size-4" />,
        info: <IconCircleInfoFill18 className="size-4" />,
        warning: <IconAlertWarningFill18 className="size-4" />,
        error: <IconCircleXmarkFill18 className="size-4" />,
        loading: <IconLoader2Fill18 className="size-4 animate-spin" />,
      }}
      style={
        {
          "--normal-bg": "var(--popover)",
          "--normal-text": "var(--popover-foreground)",
          "--normal-border": "var(--border)",
          "--border-radius": "var(--radius)",
        } as React.CSSProperties
      }
      toastOptions={{
        classNames: {
          toast: "cn-toast",
        },
      }}
      {...props}
    />
  )
}

export { Toaster }
